<!--
상품삭제(취소상품 삭제) 컴포넌트
------------------------------------
-->
<template>
    <div>
        <!-- 폼 화면 -->
        <div class="uk-flex-top form" uk-modal esc-close="false" bg-close="false">
            <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

                <div class="uk-modal-header">
                    <h4 class="uk-text-center">상품삭제</h4>
                </div>

                <div class="uk-modal-body uk-padding-remove uk-flex uk-flex-between uk-child-width-1-2 uk-flex-top">

                    <!-- 상품정보 표시 -->
                    <div class="uk-flex uk-flex-wrap uk-padding-small" style="border-right: 1px solid #eee">
                        <div class="uk-width-1-1">
                            <app-column
                                class="uk-margin-small-bottom"
                                header="상품명"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.name }}
                            </app-column>
                        </div>



                        <div class="uk-width-auto uk-text-center">
                            <div class="uk-margin-right">
                                <img
                                    :src="prod.img_url"
                                    width="100"
                                />
                            </div>

                        </div>
                        <div class="uk-width-expand">
                            <app-column
                                class="uk-margin-small-bottom"
                                header="상품번호"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.id }}
                            </app-column>

                            <app-column
                                class="uk-margin-small-bottom"
                                header="배송단계"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.state_text }}
                            </app-column>




                            <app-column
                                class="uk-margin-small-bottom"
                                header="색상"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.color }}
                            </app-column>

                            <app-column
                                class="uk-margin-small-bottom"
                                header="사이즈"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.size }}
                            </app-column>



                            <app-column
                                class="uk-margin-small-bottom"
                                header="보관장소"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.storage }}
                            </app-column>

                            <app-column
                                class="uk-margin-small-bottom"
                                header="수량"
                                header-size="medium"
                                body-size="medium"
                                header-align="left"
                                body-align="left"
                                horizontal
                                header-width="80px"
                            >
                                {{ prod.amount }}
                            </app-column>

                        </div>
                    </div>


                    <!-- 안내 -->
                    <div class="uk-padding-small">

                        <app-input-ex
                            class="uk-margin-bottom"
                            type="textarea"
                            label="사유(로그)"
                            placeholder="사유를 작성하세요"
                            :textarea-rows="5"
                            v-model="inputs.reason"
                        ></app-input-ex>
                    </div>
                </div>


                <div class="uk-modal-footer uk-text-right">
                    <div class="uk-margin-small-bottom">
                        * 삭제된 상품정보는 복구할 수 없습니다. 정말 삭제합니까?
                    </div>

                    <!--- 버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-default uk-modal-close"
                    >
                        <span uk-icon="icon: close"></span> 취소
                    </button>
                    <button
                        type="button"
                        class="uk-button uk-button-danger"
                        v-on:click="submit()"
                    >
                        <span uk-icon="icon: check"></span>
                        상품삭제(완료)
                    </button>
                </div>
            </div>
        </div>

        <!-- 결과 화면 -->
        <div class="uk-flex-top result" uk-modal esc-close="false" bg-close="false">
            <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

                <div class="uk-modal-body uk-text-center uk-text-large">
                    상품이 삭제되었습니다
                </div>

                <div class="uk-modal-footer uk-text-center">

                    <!--- 버튼 -->
                    <button
                        type="button"
                        class="uk-button uk-button-default"
                        @click="closeWindow"
                    >
                        <span uk-icon="icon: close"></span> 창닫기
                    </button>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // (object) 상품정보
                prod: {},

                // 폼화면 html 엘리먼트
                el_form: null,

                // 결과화면 html 엘리먼트
                el_result: null,

                /**
                 * 입력값
                 */
                inputs: {},
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {

                if (! this.el_form) {
                    this.el_form = $(this.$el).find('.form').get(0);
                }
                if (! this.el_result) {
                    this.el_result = $(this.$el).find('.result').get(0);
                }

                UIkit.modal(this.el_form).show();
            },

            /**
             * 폼
             * @param prod_id 상품ID
             */
            form(prod_id) {

                // 초기화
                this.inputs = {
                    reason: null,
                };

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/prods/' + prod_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.prod = response.prod;

                    // 폼띄우기
                    this.displayForm();
                });
            },

            /**
             * submit
             */
            submit() {

                // promise 생성
                let load = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'delete',
                        url: '/prods/' + this.prod.id,
                        data: _.merge({
                            '_token': this.csrfToken,
                        }, this.inputs),
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });

                // promise 처리
                load.then((response) => {
                    UIkit.modal(this.el_result).show();
                });
            },

            /**
             * 브라우저 윈도우(탭) 닫기
             */
            closeWindow() {
                window.close();
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>